/*
 * Copyright (c) 2024. Nedaware SL
 */

import {BasicEntity, BasicProperty} from "../../../basic-entity-back/annotations";
import {PropertyType} from "../../../basic-entity-back/property-type/property-type";
import {Resource} from "../../../api/resource";
import {ManagerCachingStrategy, PropertyMap} from "../../../basic-entity-back/basic-entity-interface/mapping-external";

@BasicEntity({
    name: 'Plazo',
    endpoint: 'plazos',
    isPaginated: true,
    paginationSizes: [20, 30, 50],
    modelNameProperty: 'lectura',
    managerCaching: ManagerCachingStrategy.Lazy,
    type: 'Plazo'
})
export class Plazo extends Resource {
    @BasicProperty({
        isId: true,
        name: 'ID',
        type: PropertyType.Integer()
    })
    private _id: number;

    @BasicProperty({
        name: 'Nº Días',
        type: PropertyType.Integer(),
    })
    private _numeroDias: number;

    @BasicProperty({
        name: 'Porcentaje (%)',
        type: PropertyType.Float(0, 100),
    })
    private _porcentaje: number;

    public static readonly MAP_PLAZO: PropertyMap = {
        name: 'Forma de pago',
        type: PropertyType.FutureUri('forma-pago.model.ts'),
        nullable: true
    }
    @BasicProperty(Plazo.MAP_PLAZO)
    private _formaPago;

    get lectura(): string {
        return this._numeroDias + ' días - ' + this._porcentaje + '%'
    }

    get id(): number {
        return this._id;
    }

    set id(value: number) {
        this._id = value;
    }

    get numeroDias(): number {
        return this._numeroDias;
    }

    set numeroDias(value: number) {
        this._numeroDias = value;
    }

    get porcentaje(): number {
        return this._porcentaje;
    }

    set porcentaje(value: number) {
        this._porcentaje = value;
    }

    get formaPago() {
        return this._formaPago;
    }

    set formaPago(value) {
        this._formaPago = value;
    }
}
